module.exports = __webpack_public_path__ + "img/avatar_random_2.aa1dff81.png";